import * as React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 16 16" {...props}>
      <defs></defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="#fff">
          <path d="M15.957,14.119 C15.957,15.141 15.297,15.97 14.482,15.97 C13.668,15.97 13.007,15.142 13.007,14.119 C13.007,13.098 14.482,11 14.482,11 C14.482,11 15.957,13.098 15.957,14.119 L15.957,14.119 Z"></path>
          <path d="M14.632,6.445 C13.427,5.237 11.781,5.083 9.999,5.063 L9.999,5.049 C9.999,4.516 9.626,4.082 9.165,4.082 L7.979,4.082 L7.979,2.954 C8.687,2.855 9.257,2.484 9.493,1.996 C9.755,2.112 10.113,2.185 10.509,2.185 C11.31,2.185 11.958,1.891 11.958,1.526 C11.958,1.162 11.31,0.867 10.509,0.867 C10.118,0.867 9.766,0.938 9.505,1.052 C9.239,0.466 8.49,0.041 7.598,0.041 C6.728,0.041 5.994,0.443 5.71,1.005 C5.427,0.885 5.043,0.811 4.617,0.811 C3.746,0.811 3.042,1.12 3.042,1.499 C3.042,1.879 3.746,2.186 4.617,2.186 C5.038,2.186 5.418,2.113 5.701,1.996 C5.911,2.433 6.391,2.771 7,2.91 L7,4.083 L5.832,4.083 C5.373,4.083 5,4.517 5,5.05 L5,5.06 L1.436,5.06 C0.702,5.06 0.02,5.761 0.02,6.499 C0.02,7.236 0.616,7.963 1.35,7.963 L5.003,7.963 C5.01,8.49 5.378,8.916 5.833,8.916 L9.166,8.916 C9.617,8.916 9.978,8.499 9.994,7.982 C11.191,8.031 12.178,8.2 12.669,8.691 C12.946,8.969 13.166,9.339 13.286,9.959 L15.899,9.959 C15.742,8.554 15.381,7.197 14.632,6.445 L14.632,6.445 Z"></path>
        </g>
      </g>
    </Svg>
  );
};

export default Icon;
